import { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import useOnIntersect from 'js/hooks/use-on-intersect';
import OPE from 'js/on-page-editing';

import { IEmbedBlock } from 'source/NFR.types';

const EmbedBlock: React.FC<IEmbedBlock> = ({ height, onPageEditing, src, title, width }) => {
  const wrapper = useRef<HTMLDivElement>(null);
  const hasDimensions = height && width;
  const [minHeight, setMinHeight] = useState(0);
  const [srcState, setSrcState] = useState<string | undefined>(undefined);

  useOnIntersect(wrapper, () => setSrcState(src));

  useEffect(() => {
    setMinHeight(hasDimensions ? 0 : (9 / 16) * (wrapper.current?.offsetWidth || 0));
  }, [hasDimensions]);

  const wrapperClass = cn('embed-block', { 'embed-block--has-dimensions': hasDimensions });

  return (
    <div className={wrapperClass} ref={wrapper} {...OPE(onPageEditing)}>
      <iframe
        allowFullScreen
        src={srcState}
        loading="lazy"
        height={height}
        width={width}
        title={title}
        style={{ minHeight }}
      />
    </div>
  );
};

EmbedBlock.displayName = 'EmbedBlock';

export default EmbedBlock;
